import {
  autoplayActions,
  CoreStoreType,
  GameCommunicationBetsOpenProcessor as CoreBetsOpenProcessor,
  GameCommunicationMessageType,
  toastActions,
  countTotalBet,
  Logger,
} from '@pp/core';

import type { GameStore } from '../../../store/GameStore';
import { mwStateActions } from '../../../store/slices/mwState/slice';

export class GameCommunicationBetsOpenProcessor extends CoreBetsOpenProcessor {
  process(message: GameCommunicationMessageType, store: GameStore): void {
    super.process(message, store);
    store.dispatch(mwStateActions.resetForNewGame());
  }

  checkLowBalanceAndUpdateAutoplay(store: CoreStoreType): void {
    const state = store.getState();
    const balance = state.gameState.userInfo?.balance;
    const { isInProgress, savedBet } = state.autoplay;

    if (isInProgress) {
      let totalBet = countTotalBet(savedBet?.betSpots || {}, state.gameState.currencyInfo?.digitsNumber || 0);
      if (totalBet > (balance?.amount || 0)) {
        store.dispatch(autoplayActions.stop());
        store.dispatch(toastActions.createToast('AUTOPLAY_SUPPORT_CURR_BAL'));
        Logger.logEvent('click', 'autoplay_stop', Date.now(), 1, 'NoMoney', false);
      }
    }
  }
}
